module.exports = __webpack_public_path__ + "img/picto9.9fb05e62.svg";